import React from 'react';
import LazyMetrics from '../../states-year/LazyMetrics';
import OfferActivityYear from '../../states-year/Offers/OfferActivityYear';
import OfferResponseYear from '../../states-year/Offers/OfferResponseYear';
import OfferStatusYear from '../../states-year/Offers/OfferStatusYear';
import TotalYear from '../../states-year/Offers/TotalYear';
import ClaimsByMonth from '../../states-year/Offers/ClaimsByMonth';
import ClaimCreatorYear from '../../states-year/Offers/ClaimCreatorYear';
import ClaimDeclinerYear from '../../states-year/Offers/ClaimDeclinerYear';
import ClaimDeclineReasonYear from '../../states-year/Offers/ClaimDeclineReasonYear';

export default function Offers(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="Offers"
        columns={1}
      >
        {/*<OfferActivityYear {...params} />*/}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <OfferResponseYear {...params} />
          <OfferStatusYear {...params} />
        </div>
        <OfferActivityYear {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <TotalYear {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Invitations - Offers"
        columns={1}
      >
        <ClaimsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <ClaimCreatorYear {...params} />
          <ClaimDeclinerYear {...params} />
        </div>
        <ClaimDeclineReasonYear {...params} />
      </LazyMetrics>
    </>
  );
}
